import { observer } from 'mobx-react-lite'
import i from '../../translations/i'
import { Titles } from '../../layouts/Titles'
import __catalog from './__catalog'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Alert, Button } from 'antd'
import { storeLocal } from '../../helpers/stores'
import { ProductTable } from '../../components/product_table/ProductTable'
import { ProductTableController } from '../../components/product_table/product_table.controller'

// Товары категории каталога — в том порядке, в каком их видят покупатели; порядок меняется стрелками в строке
export const CatalogProductList = observer(() => {

  const { categoryID = 0 }: any = useParams()

  const [table] = useState(() => new ProductTableController({
    endpoint: '/products/list',
    important: true,
    categoryId: `${Number(categoryID)}`,
    syncUrl: true,
    onLoaded: result => __catalog.setMeta(result),
  }))

  const role = Number(storeLocal.get('role'))

  return(
    <>
      <Titles
        title={i.t('categories:catalog')}
        breadcrumb={__catalog.tree}
        buttons={[
          { title: i.t('categories:createCategory'), href: `/shop/catalog/category/create/${categoryID}`, type: 'dashed', disabled: role === 4 || role === 6 },
          { title: i.t('categories:createProduct'), href: `/shop/catalog/product/0/${categoryID}`, type: 'dashed' },
          { title: i.t('categories:prices'), href: `/shop/mass`, type: 'dashed' }
        ]}
      />

      {(__catalog.productWithoutCategory > 0 && role !== 4) &&
        <Alert
          className="pt-alert"
          message={`${i.t('categories:without')}: ${__catalog.productWithoutCategory}`}
          type="info"
          action={<Button size="small" type="primary" href="/shop/without">{i.t('categories:withoutList')}</Button>}
          closable
        />
      }

      <ProductTable table={table} createHref={`/shop/catalog/product/0/${categoryID}`} />
    </>
  )
})
